export const createJumboEventResponseMeta = (response) => {
  return {
    is_success: true,
    is_call_required: response?.is_call_required || false,
    reso_assist_summary: response?.reso_assist_summary?.text || '',
    sm_calling_details: JSON.stringify({
      enabled: response?.sm_calling_details?.enabled || false,
      call_status: response?.sm_calling_details?.call_status?.text || '',
      selected_response:
        response?.sm_calling_details?.default_option?.value || '',
      is_skipped: response?.sm_calling_details?.is_skipped || false,
    }),
    dp_calling_details: JSON.stringify({
      enabled: response?.dp_calling_details?.enabled || false,
      call_status: response?.dp_calling_details?.call_status?.text || '',
      selected_response:
        response?.dp_calling_details?.default_option?.value || '',
      is_skipped: response?.dp_calling_details?.is_skipped || false,
    }),
    reso_assist_resolution_details: JSON.stringify({
      enabled:
        response?.reso_assist_resolution_details?.enable_resolution || false,
      is_btn_visibile:
        response?.reso_assist_resolution_details?.is_btn_visibile || false,
      header_text: response?.reso_assist_resolution_details?.header_text || '',
      unverified_display_text:
        response?.reso_assist_resolution_details?.unverified_display_text || '',
      preferred_resolution_text:
        response?.reso_assist_resolution_details?.preferred_resolution?.text ||
        '',
      preferred_resolution_subtext:
        response?.reso_assist_resolution_details?.preferred_resolution
          ?.subtext || '',
    }),
  };
};
